import getAsyncInjectors from './utils/asyncInjectors'

/**
 * Use this construct so we can import both a single Component and a "environment index" (Counter/index.js)
 * Call like:
 * .then((component) => {renderEnvironment(cb, component)})
 * or
 * .then(renderEnvironment.bind(cb))
 */
function renderEnvironment (cb, componentEnvironment = cb) {
  const callback = (componentEnvironment === cb) ? this : cb
  const environment = (componentEnvironment === cb) ? cb : componentEnvironment

  try {
    callback(null, environment.default || environment)
  } catch (e) {
    console.error('Error rendering environment:\n', e)
  }
}

export default function (store) {
  const { injectReducer, injectSagas } = getAsyncInjectors(store)

  // Because of webpack's static analysis, we can't use a variable for `System.import(<var>)` in the then() functions.
  // This means that hot reloading would become a mess; hot.accept's and nested System.import's for each watched file.
  // This is why we opted to NOT HAVE HOT-RELOADING for anything but components.
  // Note: components are hot-reloaded by the webpack configuration.
  return [
    {
      rootQuerySelector: '#taste-profile-onboarding',
      getRoutes: () => new Promise(async (resolve) => {
        const routes = await require(/* webpackChunkName: 'tasteprofile' */ 'environments/TasteProfileOnboarding/routes')
        resolve(routes.default({ store, injectReducer, injectSagas, renderEnvironment }))
      })
    }
    // @generator => DO NOT REMOVE THIS LINE: used to insert new environments by generator
  ]
}
